import template from "./template.html";
import config from "../config";

export default function (editor) {
  const { DomComponents, BlockManager } = editor;

  DomComponents.addType("text-image-bottom", {
    isComponent: (el: HTMLElement) => el.classList && el.classList.contains("solo-landing-text-bottom"),
    model: {
      defaults: {
        draggable: true,
        removable: true,
        selectable: true,
        hoverable: true,
        stylable: ["background-color"],
        traits: [
          {
            type: "checkbox",
            label: "Invert layout",
            name: "data-reverse",
            valueTrue: "1",
            valueFalse: "0",
          },
        ],
      },
    },
  });

  BlockManager.add("text-image-bottom", {
    ...config,
    label: "Title, text and image below",
    content: template,
  });
}
